import React, { FunctionComponent, useState } from 'react';
import styles from './AvatarCell.module.scss';
import {
  EmptyImg,
  ImportantIcon,
  NotFoundIcon,
  SmallEntityIcon,
  TranslateWithoutHoveringIcon,
  UserImg,
} from 'app/assets/images/icons';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';
import NewsSquareDefaultImg from 'app/assets/images/NewsSquareDefaultImg.png';
import { useModal } from 'app/context/Modal';
import { Link } from 'react-router-dom';
import { useQueryClient } from 'react-query';

interface Props {
  text?: string;
  img?: any;
  icon?: JSX.Element;
  rounded?: boolean;
  hideImg?: boolean;
  moduleName?: string;
  created_on?: any;
  withBorder?: boolean;
  showBlankImg?: boolean;
  smallCell?: boolean;
  smallImg?: boolean;
  showEntityImg?: boolean;
  tableFont?: boolean;
  showNewsDefaultImg?: boolean;
  isMultiline?: boolean;
  MarkedImportant?: boolean;
  TranslateWithoutHovering?: any;
  imageIsClick?: boolean;
  goTo?: string;
  bigImage?: boolean;
  secondText?:string;
}

const AvatarCell: FunctionComponent<Props> = ({
  hideImg,
  text,
  secondText,
  img,
  icon,
  rounded,
  moduleName,
  created_on,
  showBlankImg,
  withBorder,
  smallCell,
  smallImg,
  showEntityImg,
  tableFont,
  showNewsDefaultImg,
  isMultiline,
  MarkedImportant,
  TranslateWithoutHovering,
  imageIsClick,
  goTo,
  bigImage,
}) => {
  const modal = useModal();
  const queryClient = useQueryClient();
  const [isImageLoaded,setIsImageLoaded] = useState(true);
  return (
    <div
      className={`${styles.AvatarCell} ${smallImg && styles.smallImg} ${
        bigImage && styles.bigImage
      }`}
      data-testid="AvatarCell-testid"
    >
      <div className={styles.icon}>{icon && icon}</div>
      {hideImg ? null : img ? (
        <div
          data-testid="image-wrapper"
          className={`${styles.imgContainer} ${
            moduleName === 'videos' ? 'thumbnail' : ''
          } ${rounded ? styles.rounded : ''} ${
            withBorder ? styles.borderStyle : ''
          } ${smallCell ? styles.smallCell : ''}`}
          onClick={() => (imageIsClick ? modal.show({ imageUrl: img }) : null)}
          style={{ cursor: imageIsClick ? 'pointer' : undefined ,border:!isImageLoaded?'1px solid':''}}
        >
          {
          isImageLoaded ? <img onError={()=>setIsImageLoaded(false)} src={img} /> 
          : showNewsDefaultImg ? <img src={NewsSquareDefaultImg} />  
          : <NotFoundIcon />
          }
        </div>
      ) : showBlankImg ? (
        <div
          className={`${styles.imgContainer}  ${rounded ? styles.rounded : ''}`}
          data-testid="blank-img"
        >
          <EmptyImg />
        </div>
      ) : showNewsDefaultImg ? (
        <div
          className={`${styles.imgContainer}  ${
            smallCell ? styles.smallCell : ''
          } ${rounded ? styles.rounded : ''}`}
          data-testid="showNewsDefaultImg"
        >
          <img src={NewsSquareDefaultImg} />
        </div>
      ) : showEntityImg ? (
        <div
          className={`${styles.imgContainer}  ${
            smallCell ? styles.smallCell : ''
          }`}
          data-testid="SmallEntityIcon"
        >
          <SmallEntityIcon />
        </div>
      ) : (
        <div
          className={`${styles.imgContainer} ${
            smallCell ? styles.smallCell : ''
          }`}
        >
          <UserImg />
        </div>
      )}
      <div
        className={`${hideImg ? styles.textHolder : styles.textHolderWithImg} ${
          smallCell ? styles.smallCell : ''
        }${TranslateWithoutHovering ? styles.Translate : ''}`}
      >
        {text &&
          (goTo ? (
            <Link
              to={goTo}
              onClick={() => queryClient.removeQueries('influencerDetails')}
              data-testid="goTo-testid"
            >
              <div
                className={`${styles.nameStyle} ${
                  tableFont ? styles.tableFont : ''
                } ${
                  MarkedImportant || TranslateWithoutHovering
                    ? styles.minWidth
                    : ''
                } ${goTo && styles.clickable}`}
                dir="auto"
                title={text}
                data-multiline={isMultiline}
              >
                {text}
              </div>
            </Link>
          ) : (
            <div
              className={`${styles.nameStyle} ${
                tableFont ? styles.tableFont : ''
              } ${
                MarkedImportant || TranslateWithoutHovering
                  ? styles.minWidth
                  : ''
              } `}
              dir="auto"
              title={text}
              data-multiline={isMultiline}
              data-testid="isMultiline-text"
            >
              {text}
            </div>
          ))}
          {secondText && <p>{secondText}</p>}
        {MarkedImportant && (
          <span className={styles.markedImportant} data-testid="ImportantIcon">
            <ImportantIcon />
          </span>
        )}
        {TranslateWithoutHovering?.length > 0 && (
          <span
            className={styles.TranslateWithoutHovering}
            data-testid="TranslateWithoutHovering"
          >
            <TranslateWithoutHoveringIcon />
          </span>
        )}
        {created_on && (
          <div className={styles.time} data-testid="date-time-block">
            <span>{dateTimeFormatter.distance(created_on)}</span>
            <span>
              {dateTimeFormatter.date(created_on)} -
              {dateTimeFormatter.time(created_on)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AvatarCell;
